export default __webpack_public_path__ + "static/media/notadmin.4861ae77.svg";